import { BaseHandler } from "../../infrastructure/base-handlers";
import { clearActivityHistoryCollections } from "../clear/action";
import { activityHistoryFiltersSlice } from "../filter/slice";

export class RefreshHistoryItemsHandler extends BaseHandler {
  async handle() {
    this.store.dispatch(activityHistoryFiltersSlice.actions.clearCustomFilters());
    this.store.dispatch(clearActivityHistoryCollections());
    this.api.broker.publish(this.api.broker.events.activityHistory.refreshDataRequested);
  }
}
